{/* 
    Adds some utility functions to help support the UI when the user has an active Jet Bridge Pledge Manager cart     
*/}

var jbUtilities = ( function() {

    let toggleBodyClass = function() {

        let pmUrl = window.localStorage.getItem( 'jb-pm-url');
        if(pmUrl) {            
            document.body.classList.add('jb-pm-active');
        } else {
            document.body.classList.remove('jb-pm-active');
        }
    }

    let setupLinkLocations = function() {
        var linksToPm = document.querySelectorAll('.jb-link-to-pm');
        for( let link of linksToPm) {
            let pmUrl = window.localStorage.getItem( 'jb-pm-url');
            link.href = pmUrl;                       
        }
    };
    let resetPm = function() {
        window.localStorage.removeItem( 'jb-pm-url');
        window.localStorage.removeItem( 'jb-pm-campaign-name');
        fetch('/cart/clear.js')
        .finally( () => {        
            window.location = window.location;
        });
        return false;
    };

    let handleClicksToCheckout = function() {
        window.addEventListener('click',function(e){        
            if(e.target.name == 'checkout') {            
                var pmUrl = localStorage.getItem('jb-pm-url');            
                if(pmUrl) {
                    e.preventDefault();
                    window.location = pmUrl;
                }
            }
        });
    };

    return {
        initialize: function() {
            toggleBodyClass();
            setupLinkLocations();
            handleClicksToCheckout();            
        },
        hasActivePmCart: function() {
            return window.localStorage.getItem('jb-pm-url') !== null;
        },
        currentCampaignName: function() {
            if( window.localStorage.getItem('jb-pm-url') ) {
                return window.localStorage.getItem('jb-pm-campaign-name') ?? null;
            }
            return null;
        },
        resetPm: resetPm
    }
} )();

window.addEventListener('load',function(e){        
    jbUtilities.initialize();
});